import {
  Grid,
  Table,
  TableBody,
  TableCell,
  TableRow,
  TextField,
  TableHead,
  TableSortLabel,
  IconButton,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
  Checkbox
} from '@material-ui/core';
import React, { Component } from 'react';
import { apiBatchRequest, downloadReport } from '../../utils/api_service';
import { API_URL } from '../../constants/api';
import commonLabels from '../../constants/messageConstants';
import { ShowToast, toastType } from '../../utils/toast-service';
import Reports from './Reports';
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider
} from '@material-ui/pickers';
import './report.less';
import DateFnsUtils from '@date-io/date-fns';
import { DateFormat, DEPARTMENT } from '../../constants/appConstants';
import moment from 'moment';
import Autocomplete from '@material-ui/lab/Autocomplete';
import _, { cloneDeep } from 'lodash';
import PageHeader from '../common/PageHeader';
import ReportButtons from './ReportButtons';
import {
  BuildObject,
  ExpandAll,
  GenerateAbsoluteURL,
  removeDuplicates,
  SortArray,
  IsAutoRunPagesEnabled
} from '../../utils/helper';
import { getFormattedHeaders, getFormattedValues } from '../../utils/formatData';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import TableWithPaginations from './TableWithPaginations';
import { Add, Remove } from '@material-ui/icons';
import { yearEndBonusRadio } from '../../constants/MockData';
import PageLandingMessage from '../common/PageLandingMessage/PageLandingMessage'

// Year End Bonus Report Component
export default class YearEndBonusReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showMain: false,
      reportData: [],
      originalReportData: [],
      startDate: moment().startOf('month').format(DateFormat),
      showReport: false,
      propertyMasterData: [],
      marketMasterData: [],
      property: [{ propertyName: 'All' }],
      market: [{ marketName: 'All' }],
      order: 'desc',
      orderByColumn: '',
      rows: [],
      groupBy: 'Market',
      showDetails: true,
      supervisorEmployee: [{ employeeName: 'All' }],
      supervisorEmployeeMasterData: [],
      employee: [{ employeeName: 'All' }],
      employeeMasterData: [],
      isAutoRunEnabled: IsAutoRunPagesEnabled(),
      isSubmitButtonClicked: false
    };

    this.baseState = this.state;
  }

  // Event to Get Master data before Component is mounted
  componentDidMount() {
    window.scrollTo(0, 0);
    this.GetMasterData();
  }

  // Click event to go the Master report list
  goBack = () => {
    this.setState({
      showMain: true
    });
  };

  // Handle date change event
  handleDateChange = (date, name) => {
    this.setState({
      [name]: moment(date).format(DateFormat)
    });
  };

  // Get Master data to fill filters
  GetMasterData = () => {
    this._asyncRequest = apiBatchRequest([
      {
        url: API_URL.Employee.GetEmployeeMasterData + '?showInActive=true', // + '&departmentId=' + DEPARTMENT.MANAGEMENT_SERVICE,
        key: 'employeeMasterData' // 'supervisorEmployeeMasterData'
      },
      {
        url: API_URL.Property.GetPropertyMasterData,
        key: 'propertyMasterData'
      },
      {
        url: API_URL.Market.GetMarketMasterdata,
        key: 'marketMasterData'
      }
    ])
      .then(
        ({
          propertyMasterData,
          employeeMasterData, // supervisorEmployeeMasterData,
          marketMasterData
        }) => {
          this._asyncRequest = null;
          if (propertyMasterData.success !== true) {
            ShowToast(
              commonLabels.somethingWrong,
              toastType.ERROR,
              5000,
              500,
              'Server error'
            );
          }
          this.setState({
            propertyMasterData: propertyMasterData.data,
            marketMasterData: marketMasterData.data,
            employeeMasterData: employeeMasterData.data || [],
            supervisorEmployeeMasterData: cloneDeep((employeeMasterData.data || []).filter(x => x.departmentId === DEPARTMENT.MANAGEMENT_SERVICE) || [])
          }, () => {
            if(this.state.isAutoRunEnabled || this.state.isSubmitButtonClicked) {
              this.GetYearEndBonusReport();
            }            
          });
        }
      )
      .catch(() => {
        this._asyncRequest = null;
      });
  };

  // Call API to get Year End Bonus report
  GetYearEndBonusReport = () => {
    const { property, market, groupBy, employee, supervisorEmployee } = this.state;
    const propertyId = _.cloneDeep(property.map((x) => x.propertyId));
    const marketId = _.cloneDeep(market.map((x) => x.marketId));
    const employeeId = _.cloneDeep(employee.map((x) => x.employeeId));

    const payPeriodStartDate = this.state.startDate;
    const supervisorId = _.cloneDeep(supervisorEmployee.map((x) => x.ultiProEmployeeId));

    const params = {
      year: moment(moment(payPeriodStartDate).format('DD/MM/YYYY'), 'DD/MM/YYYY').year(),
      propertyId: propertyId.join('|'),
      marketId: marketId.join('|'),
      employeeId: employeeId.join('|'),
      supervisorId: supervisorId.join('|'),
      groupBy: groupBy,
      showDetails: 1
    };

    this._asyncRequest = apiBatchRequest([
      {
        url: API_URL.Json.GetYearEndBonusReport,
        params,
        key: 'reportData'
      }
    ])
      .then(({ reportData }) => {
        this._asyncRequest = null;
        if (reportData.success !== true) {
          ShowToast(
            commonLabels.somethingWrong,
            toastType.ERROR,
            5000,
            500,
            'Server error'
          );
        }
        reportData.data = (reportData.data || []).map(y => {
          if (y.IsChild === 0) {
            y.isExpand = this.state.showDetails;
          }
          return y;
        });
        const fieldName1 = groupBy === 'Employee'
          ? 'EmployeeName'
          : groupBy === 'Market' ? 'MarketName' : 'PropertyName';

        const obj = ExpandAll(
          (reportData.data || []),
          cloneDeep((reportData.data || []).filter(x => x.IsChild === 0)),
          this.state.showDetails,
          this.state.showDetails,
          fieldName1,
          'PropertyId'
        );

        this.setState({
          originalReportData: (obj.filterdOriginalReportData || []),
          reportData: cloneDeep((obj.filterdReportData || []).filter(x => x.IsChild === 0)),
          configuration: reportData.config,
          showReport: true,
          isSubmitButtonClicked: true,
          rows: this.renderTableRow(SortArray(cloneDeep((obj.filterdReportData || []).filter(x => x.IsChild === 0)), (obj.filterdOriginalReportData || []), this.state.order, this.state.orderByColumn, fieldName1), reportData.config)
        });
      })
      .catch(() => {
        this._asyncRequest = null;
      });
  };

  // Handle sort event
  handleRequestSort = (property, type) => {
    const isAsc = this.state.orderByColumn === property && this.state.order === 'asc';
    const fieldName1 = this.state.groupBy === 'Employee' ? 'EmployeeName' : (this.state.groupBy === 'Market' ? 'MarketName' : 'PropertyName');

    let rows = [];
    rows = [...rows, ...this.renderTableRow(
      SortArray((this.state.reportData || []), this.state.originalReportData, isAsc ? 'desc' : 'asc', property, fieldName1),
      this.state.configuration
    )];
    this.setState({
      order: isAsc ? 'desc' : 'asc',
      orderByColumn: property,
      rows
    });
  }

  // Render table with data
  renderTable = (rows) => {
    const { order, orderByColumn, configuration } = this.state;
    return (
      <Table className="reportTable" id="rptTable">
        <TableHead className='background-table-header'>
          <TableRow>
            {configuration?.filter(x => x.isVisible === true).map((config) => (
              config.dbColumn !== 'PropertyType' 
                ? (
                    <TableCell
                      key={config.dbColumn}
                      sortDirection={orderByColumn === config.dbColumn ? order : false}
                    >
                      {
                        <TableSortLabel
                          active={orderByColumn === config.dbColumn}
                          direction={orderByColumn === config.dbColumn ? order : 'asc'}
                          onClick={() => { this.handleRequestSort(config.dbColumn, config.dataFormat); }}
                        >
                          {config.dataFormat !== undefined ? getFormattedHeaders(config.uiColumn, config.dataFormat) : config.uiColumn
                          }
                        </TableSortLabel>
                      }
                    </TableCell>
                  )
              : (
                  <TableCell key={config.dbColumn}>
                    {config.dataFormat !== undefined ? getFormattedHeaders(config.uiColumn, config.dataFormat) : config.uiColumn}
                  </TableCell>
                )
            ))}
          </TableRow>
        </TableHead>
        <TableBody>{rows}</TableBody>
      </Table>
    );
  };

  // Reset filter event
  resetPage = () => {
    this.setState({
      startDate: moment().startOf('month').format(DateFormat),
      showReport: false,
      property: [{ propertyName: 'All' }],
      supervisorEmployee: [{ employeeName: 'All' }],
      market: [{ marketName: 'All' }],
      employee: [{ employeeName: 'All' }],
      showDetails: true,
      groupBy: 'Market',
      isSubmitButtonClicked: false,
      reportData: []
    }, this.GetMasterData());    
  };

  // Event to print the report
  handlePrintClick = () => {
    this.setState(
      {
        printPage: true
      },
      window.print()
    );
  };

  // Handle filter change event
  handleChange = (_e, value, name, optionLabel) => {
    if ((this.state[name] || []).find(x => x[optionLabel] === 'All') === undefined) {
      if (value && value.length === 0) {
        value = [{ [optionLabel]: 'All' }];
        this.setState({ [name]: value });
      } else if ((value || []).find(x => x[optionLabel] === 'All')) {
        this.setState({ [name]: [{ [optionLabel]: 'All' }] });
      } else {
        this.setState({ [name]: value });
      }
    } else {
      value = (value || []).filter(x => x[optionLabel] !== 'All');
      if (value && value.length === 0) {
        value = [{ [optionLabel]: 'All' }];
      }
      this.setState({ [name]: value });
    }
  };

  // Render row in the table
  renderTableRow = (data, columns) => {
    return this.renderTableCell(
      data,
      columns,
      []
    );
  };

  // Handle click event of Submit button
  handleClick = (data) => {
    const { originalReportData, reportData, configuration, order, orderByColumn, groupBy, showDetails } = this.state;
    const fieldName = groupBy === 'Employee' ? 'EmployeeName' : (groupBy === 'Market' ? 'MarketName' : 'PropertyName');

    const object = BuildObject(reportData, originalReportData, 'PropertyId', data, true, fieldName);
    this.setState({
      originalReportData: object.originalReportData,
      reportData: object.reportData,
      rows: this.renderTableRow(SortArray(cloneDeep((object.reportData || []).filter(x => x.IsChild === 0)), (object.originalReportData || []), order, orderByColumn, fieldName), configuration)

    });
  }

  // Render cell in the table row
  renderTableCell = (groupedData, columns, tableCell = [], rowCount = 0) => {
    groupedData.filter(x => x.RowType !== 'T').forEach((d, i) => {
      const evenOddClass =
        tableCell.length % 2 === 0 ? ' rpt rpt-even ' : ' rpt rpt-odd ';
      const key = i + '_' + d.PropertyId + rowCount + '_' + i;
      tableCell.push(
        <TableRow key={key} className={'rpt-topBorder'}>
          {
            columns.map((col, index) => {
              return (
                <>
                  {
                    col.isVisible
                      ? <TableCell key={key + index} className={evenOddClass + 'rpt-topBorder' + ' year-end-padding'} >
                        <>
                          {index === 0 && d.IsChild === 0
                            ? <IconButton
                              key={key + index}
                              aria-label="expand row"
                              size="small"
                              style={{ padding: '0px', cursor: 'pointer' }}
                              onClick={(e) => {
                                e.stopPropagation();
                                this.handleClick(d);
                              }}
                            >
                              {(d.isExpand !== true
                                ? <Add className="collapse-button" fontSize={'small'} />
                                : <Remove className="collapse-button" fontSize={'small'} />)}
                            </IconButton>
                            : (index === 0 && d.IsChild === 1)
                              ? <>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                <IconButton
                                  key={key + index + d.IsChild}
                                  aria-label="expand row"
                                  size="small"
                                  style={{ padding: '0px', cursor: 'pointer' }}
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    this.handleClick(d);
                                  }}
                                >
                                  {(d.isExpand !== true
                                    ? <Add className="collapse-button" fontSize={'small'} />
                                    : <Remove className="collapse-button" fontSize={'small'} />)}
                                </IconButton>
                              </>
                              : index === 0 && d.IsChild === 2 && <>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</>
                          }
                          {getFormattedValues(
                            this.getPropertyTypeValue(col.dbColumn, d[col.dbColumn], d.IsChild),
                            col.dataFormat, false, undefined, undefined, undefined, undefined, false, false, false, undefined, 'Percent')}
                        </>
                      </TableCell>
                      : ''
                  }

                </>
              );
            })
          }

        </TableRow>
      );
      rowCount++;
    });
    groupedData.filter(x => x.RowType === 'T').forEach((d, i) => {
      const evenOddClass =
        tableCell.length % 2 === 0 ? ' rpt rpt-even ' : ' rpt rpt-odd ';
      const key = i + '_' + d.PropertyId + rowCount + '_' + i;
      tableCell.push(
        <TableRow key={key} className={'rpt-topBorder'}>
          {
            columns.map((col, index) => {
              return (
                <>
                  {
                    col.isVisible
                      ? <TableCell key={key + index} className={evenOddClass + 'rpt-topBorder' + ' year-end-padding'} >
                        <b>
                          {getFormattedValues(d[col.dbColumn], col.dataFormat, false, undefined, undefined, undefined, undefined, false, false, false, undefined, 'Percent')}
                        </b>
                      </TableCell>
                      : ''
                  }

                </>
              );
            })
          }

        </TableRow>
      );
      rowCount++;
    });
    if (groupedData?.length <= 0) {
      tableCell.push(<TableRow> <TableCell colSpan={8} align='center'>No records found</TableCell> </TableRow>);
    }
    return tableCell;
  }

  //Get Property Type value based on selected grouping. Property Type will be shown in front of Property Name only. 
  getPropertyTypeValue = (columnName, columnValue, childSequence) => {
    if (columnName !== 'PropertyType') {
      return columnValue;
    } else {
      const { groupBy } = this.state;
      if ((groupBy === 'Market' && childSequence === 1) ||
        (groupBy === 'Property' && childSequence === 0) ||
        (groupBy === 'Employee' && childSequence === 2)){
        return columnValue;
      } else {
        return null;
      }
    }
  }

  // Download report event
  downloadFile = (fileMimeType, type, isPrint = false) => {
    let { property, startDate, groupBy, showDetails, supervisorEmployee, market, employee } = this.state;
    property = property.filter(x => x.propertyName !== 'All');
    market = market.filter(x => x.marketName !== 'All');
    const propertyId = _.cloneDeep(property.map((x) => x.propertyId));
    const marketId = _.cloneDeep(market.map((x) => x.marketId));
    const supervisorId = _.cloneDeep(supervisorEmployee.map((x) => x.ultiProEmployeeId));
    const employeeId = _.cloneDeep(employee.map((x) => x.employeeId));

    const dataValue = [
      {
        key: 'Year',
        value: moment(moment(startDate).format('DD/MM/YYYY'), 'DD/MM/YYYY').year()
      },
      {
        key: 'GroupBy',
        value: groupBy
      },
      {
        key: 'ShowDetails',
        value: showDetails ? 1 : 0
      }
    ];
    dataValue.push({ key: 'PropertyId', value: (propertyId.join('|') === undefined || propertyId.join('|') === '') ? '0' : propertyId.join('|') });
    dataValue.push({ key: 'supervisorId', value: (supervisorId.join('|') === undefined || supervisorId.join('|') === '') ? '0' : supervisorId.join('|') });
    dataValue.push({ key: 'MarketId', value: (marketId.join('|') === undefined || marketId.join('|') === '') ? '0' : marketId.join('|') });
    dataValue.push({ key: 'EmployeeId', value: (employeeId.join('|') === undefined || employeeId.join('|') === '') ? '0' : employeeId.join('|') });

    const url = GenerateAbsoluteURL(dataValue, [], 'Employee%20Year%20End%20Bonus%20Report', type, false, true);

    downloadReport(
      url,
      'Year End Bonus Report',
      fileMimeType,
      type,
      isPrint
    );
  }

  // Handle change event of radio button
  handleRadioChange = (value, fieldName, isCall = false, showDetails = false) => {
    const { originalReportData, reportData, configuration, order, orderByColumn, groupBy } = this.state;
    const fieldName1 = groupBy === 'Employee'
      ? 'EmployeeName'
      : groupBy === 'Market' ? 'MarketName' : 'PropertyName';

    const obj = ExpandAll(originalReportData, reportData, value, showDetails, fieldName1, 'PropertyId');
    this.setState({
      originalReportData: obj.filterdOriginalReportData,
      reportData: obj.filterdReportData,
      rows: this.renderTableRow(SortArray(cloneDeep((obj.filterdReportData || []).filter(x => x.IsChild === 0)), (obj.filterdOriginalReportData || []), order, orderByColumn, fieldName1), configuration),
      [fieldName]: value
    }, () => {
      if (isCall === true) {
        this.GetYearEndBonusReport();
      }
    });
  }

  // Render component
  render() {
    const {
      showMain,
      reportData,
      startDate,
      showReport,
      propertyMasterData,
      marketMasterData,
      supervisorEmployeeMasterData,
      employeeMasterData,
      rows,
      showDetails
    } = this.state;

    if (propertyMasterData.find(x => x.propertyName === 'All') === undefined) {
      propertyMasterData.unshift({ propertyName: 'All' });
    }
    if (marketMasterData.find(x => x.marketName === 'All') === undefined) {
      marketMasterData.unshift({ marketName: 'All' });
    }
    if (employeeMasterData.find(x => x.employeeName === 'All') === undefined) {
      employeeMasterData.unshift({ employeeName: 'All' });
    }
    if (supervisorEmployeeMasterData.find(x => x.employeeName === 'All') === undefined) {
      supervisorEmployeeMasterData.unshift({ employeeName: 'All' });
    }

    return (
      <div>
        {showMain
          ? (
            <Reports></Reports>
          )
          : (
            <>
              <PageHeader
                key={'Year_End_Bonus_Report'}
                title={'Year End Bonus Report'}
                actionsConfig={[
                  {
                    icon: (
                      <ArrowBackIcon
                        size="small"
                        className="back-button no-print"
                      />
                    ),
                    onClick: this.goBack,
                    title: 'Back to Report'
                  }
                ]}
              >
                Year End Bonus Report
              </PageHeader>
              <Grid
                container
                spacing={3}
                className="no-print row bottom-xs"
                style={{ marginLeft: '10px' }}
              >
                <Grid item xs={12} lg={3}>
                  <Autocomplete
                    multiple
                    blurOnSelect
                    value={this.state.market}
                    onChange={(e, val) => this.handleChange(e, val, 'market', 'marketName')}
                    id="tags-standard"
                    options={removeDuplicates(marketMasterData, 'marketName')}
                    limitTags={1}
                    getOptionLabel={(option) => option.marketName}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="standard"
                        label="Market"
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12} lg={3}>
                  <Autocomplete
                    multiple
                    blurOnSelect
                    value={this.state.property}
                    onChange={(e, val) => this.handleChange(e, val, 'property', 'propertyName')}
                    id="tags-standard"
                    options={removeDuplicates(propertyMasterData, 'propertyName')}
                    limitTags={1}
                    getOptionLabel={(option) => option.propertyName}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="standard"
                        label="Property"
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12} lg={3}>
                  <Autocomplete
                    multiple
                    blurOnSelect
                    value={this.state.employee}
                    onChange={(e, val) => {
                      this.handleChange(e, val, 'employee', 'employeeName');
                    }
                    }
                    id="tags-standard"
                    options={removeDuplicates(employeeMasterData, 'employeeName')}
                    limitTags={1}
                    getOptionLabel={(option) => option.employeeName}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="standard"
                        label="Employee Name"
                      />
                    )}
                  />
                </Grid>

                <Grid item xs={12} lg={3}>
                  <Autocomplete
                    multiple
                    blurOnSelect
                    value={this.state.supervisorEmployee}
                    onChange={(e, val) => {
                      this.handleChange(e, val, 'supervisorEmployee', 'employeeName');
                    }
                    }
                    id="tags-standard"
                    options={removeDuplicates(supervisorEmployeeMasterData, 'employeeName')}
                    limitTags={1}
                    getOptionLabel={(option) => option.employeeName}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="standard"
                        label="Supervisor Name"
                      />
                    )}
                  />
                </Grid>

                <Grid item xs={12} lg={3}>
                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <Grid container>
                      <KeyboardDatePicker
                        views={['year']}
                        margin="normal"
                        id="date-picker-dialog"
                        label="Year"
                        name="startDate"
                        value={startDate}
                        onChange={(e) => this.handleDateChange(e, 'startDate')}
                        KeyboardButtonProps={{
                          'aria-label': 'change date'
                        }}
                        className="w-100"
                        inputProps={{ readOnly: true }}
                      />
                    </Grid>
                  </MuiPickersUtilsProvider>
                </Grid>
                <Grid item xs={12} lg={3}>
                  <FormControl component="fieldset">
                    <FormControlLabel
                      key={'checkbox_1'}
                      value={showDetails}
                      control={
                        <Checkbox
                          color="primary"
                          checked={showDetails}
                          onChange={(event) => {
                            this.handleRadioChange(event.target.checked, 'showDetails', false, true);
                          }}
                        />
                      }
                      label={'Show Details'}
                      labelPlacement="end"
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={12} lg={3}>
                  <div> {/* className="row pageFilter-container bottom-xs start-xs"> */}
                    <div> {/* className="col-sm-9 default-text"> */}
                      <FormControl component="fieldset">
                        <RadioGroup
                          row
                          aria-label="position"
                          name="position"
                          value={this.state.groupBy}
                        >
                          {(yearEndBonusRadio || []).map((col, i) =>
                          (
                            <FormControlLabel
                              key={col.value + i}
                              value={col.value}
                              control={<Radio color="primary"
                                onChange={(e, val) => this.handleRadioChange(col.value, 'groupBy', true)}

                              />}
                              label={col.value}
                              labelPlacement="end"
                            />
                          )
                          )}
                        </RadioGroup>
                      </FormControl>
                    </div>
                  </div>
                </Grid>
                <ReportButtons
                  resetPage={this.resetPage}
                  handleSubmit={this.GetYearEndBonusReport}
                  handleClickOpen={this.handleClickOpen}
                  handlePrintClick={this.handlePrintClick}
                  downloadFile={this.downloadFile}
                  data={reportData}
                  hideAdvanceLink={true}
                />
              </Grid>
              {(this.state.isAutoRunEnabled === false && this.state.isSubmitButtonClicked === false) && 
                (reportData === null || reportData.length <= 0) && (
                  <PageLandingMessage/>
                )
              }             
              {showReport && (reportData == null || reportData.length === 0) && (
                <Grid container spacing={4}>
                  <Grid
                    container
                    direction="row-reverse"
                    justify="center"
                    alignItems="stretch"
                  >
                    <label className="item-big">No Data Available.</label>
                  </Grid>
                </Grid>
              )}
              {showReport && reportData !== null && reportData.length > 0 && (
                <div className="container" style={{ marginTop: '1rem' }}>
                  <TableWithPaginations
                    tableData={rows}
                    renderTable={this.renderTable}
                    order={this.state.order}
                    oBy={this.state.orderByColumn}
                  />
                </div>
              )}
            </>
          )
        }
      </div>
    );
  }
}
